import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f6e7255"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "language-button" }
const _hoisted_2 = {
  key: 0,
  class: "language-button__dropdown"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { style: {"margin-left":"8px"} }

import {ref} from "vue";
import Language from "@/models/Language";
import RepositoryFactory from "@/factories/RepositoryFactory";
import localization from "@/core/localization";



export default /*#__PURE__*/_defineComponent({
  __name: 'CLanguageButton',
  setup(__props) {

const isActive = ref(false)

const clickHandle = (event: MouseEvent) => {
  if (event.target instanceof HTMLElement) {
    if (!event.target.closest('.language-button')) {
      disable()
    }
  }
}

const active = () => {
  document.addEventListener('click', clickHandle)
  isActive.value = true
}

const disable = () => {
  document.removeEventListener('click', clickHandle)
  isActive.value = false
}

const toggle = () => {
  if (isActive.value) {
    disable()
  } else {
    active()
  }
}

const select = (language: Language) => {
  currentLanguage.value = language
  localStorage.setItem('locale', language.name.toLowerCase())
  localization.global.locale = language.name == 'EN' ? 'en' : 'ru'
  disable()
}

const languages = RepositoryFactory
    .default()
    .getLanguages()

let locale = localStorage.getItem('locale')
if (!locale) {
  locale = navigator.language.split('-')[0]
}

const currentLanguage = ref(languages.find(item => locale == item.name.toLowerCase()))

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle()))
    }, [
      _createVNode(_component_ion_icon, {
        name: "language-outline",
        style: {"font-size":"24px"}
      })
    ]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (isActive.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["language-button__dropdown_item", { 'language-button__dropdown_item--active': currentLanguage.value.name === item.name}]),
                  key: index,
                  onClick: ($event: any) => (select(item))
                }, [
                  _createElementVNode("img", {
                    src: item.img,
                    alt: item.name,
                    style: {"width":"16px","height":"16px"}
                  }, null, 8, _hoisted_4),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1)
                ], 10, _hoisted_3))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})